import { useEffect, useRef } from 'react';
import { ButtonLoading, AutocompleteV, Icons } from 'components';
import { useProductsList } from 'hooks';
import { Grid, Dialog, DialogContent, IconButton, DialogTitle } from '@mui/material';
import { useStyles } from './style';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import DealerService from '../services';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';

export default function AddDealerDialog({ open, setOpen, tableRef, dealerBizId }) {
  const { loading, setLoading, productSearchText, setProductSearchText } = useCustomHook();
  const { formState: { errors }, control, getValues, handleSubmit, register, unregister, setError } = useForm();

  const { getProductsList, productsList, productsLoading } = useProductsList();
  const classes = useStyles();
  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;

  useEffect(() => {
    delayedQuery(productSearchText, getProductsList);
  }, [productSearchText]);

  const addAllowedProduct = async () => {
    const data = getValues();
    if (!data.product) {
      setError('product', { message: 'فیلد محصول اجباری است' });
    } else {
      try {
        setLoading(true);
        await DealerService.addDealerProductPermission({
          dealerBizId,
          productId: data?.product?.id,
        });
        createToast('موفق', 'محصول با موفقیت به لیست مجوزها اضافه شد', 'success');

        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100);
      } catch (error) {
      } finally {
        setLoading(false);
        setOpen(false);
      }
    }
  };
  const onClose = () => setOpen(false);
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
      fullWidth
      open={open}
      className={classes.dialogMain}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose} className={classes.title}>
        افزودن محصول به لیست مجوز ها
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <Icons icon='Close' color="#939393" size="20" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={12}>
            <AutocompleteV
              placeholder="جستجو و انتخاب کنید..."
              control={control}
              filterOptions={(options, state) => options}
              errors={errors}
              register={register}
              rules={['required']}
              name="product"
              label="محصول"
              list={productsList}
              preventAddCustomOption
              loading={productsLoading}
              getOptionSelected={(option, value) => option.id === value.id}
              onInputChange={(e) => {
                if (e?.target?.value === productSearchText) return;
                setProductSearchText(e?.target?.value ?? '');
              }}
              disableClearable
            />
            {errors.product && (
              <span className={classes.errorMesssage}>{errors.product?.message}</span>
            )}
          </Grid>
          <Grid
            md={12}
            xs={12}
            lg={12}
            style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px' }}
          >
            <ButtonLoading
              name="افزودن"
              loading={loading}
              variant="contained"
              color="primary"
              className={classes.addButton}
              onClick={handleSubmit(addAllowedProduct)}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
